import { styled, Typography } from '@mui/material';

export const TruncatedCellText = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.secondary.main, // #111C2D
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  width: '100%',
  lineHeight: 1.3,
  maxHeight: `${1.3 * 2}em`,
}));
